import { useState } from 'react';
import { useDeleteNotificationTarget } from '../../../hooks/queries/logQueries';
import CloseIcon from '../../../assets/icons/close.svg?react';

const AlertTargetDeleteModal = ({ onClose, target, onSuccess }) => {
  const deleteNotificationTarget = useDeleteNotificationTarget();
  const [isPending, setIsPending] = useState(false);
  const handleDelete = async () => {
    setIsPending(true);
    try {
      await deleteNotificationTarget.mutateAsync(target.NotificationTargetSysId);
      onSuccess();
    } catch (error) {
      console.error('알림 대상 삭제 실패:', error);
      alert('알림 대상 삭제에 실패했습니다.');
    } finally {
      setIsPending(false);
    }
  };
  return (
    <div className="modal-background">
      <div className="modal-container alert-target-delete-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>알림 대상 삭제</h3>
          <button className="close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content">
          <p className="text-b2-400 text-gray-800 my-10">알림 대상을 삭제하시겠습니까?</p>
          <table className='gray-table'>
            <tr>
              <th>대상타입</th>
              <td>{target.TargetType}</td>
            </tr>
            <tr>
              <th>대상값</th>
              <td>{target.TargetValue}</td>
            </tr>
          </table>
        </div>
        <div className="modal-footer">
          <button className="btn btn-primary big-btn w-full" onClick={handleDelete} disabled={isPending}>{isPending ? '삭제중...' : '삭제'}</button>
        </div>
      </div>
    </div>
  )
}

export default AlertTargetDeleteModal